import React, { useState, useEffect } from 'react';
import pb from '../../lib/pocketbase';

const ClientProjectSpecifications = ({ projectId }) => {
    const [spec, setSpec] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (projectId) {
            pb.collection('specifications').getFirstListItem(`project="${projectId}"`)
                .then(res => setSpec(res))
                .catch(() => setSpec(null)) // Ignore if not found
                .finally(() => setLoading(false));
        }
    }, [projectId]);

    if (loading) return null;
    // Don't show drafts to client
    if (!spec || spec.status === 'draft') return null;

    return (
        <div className="client-spec-card" style={{
            marginTop: 24,
            padding: 24,
            background: 'var(--card-bg, #fff)',
            border: '1px solid var(--border-color, #e2e8f0)',
            borderRadius: 16
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <h3 style={{ margin: 0, fontSize: '1.2rem', color: 'var(--text-primary, #0f172a)' }}>Cahier des Charges & Suivi</h3>
                {spec.status === 'review' && (
                    <span style={{ padding: '4px 10px', background: '#fffbeb', color: '#b45309', borderRadius: 99, fontSize: '0.75rem', fontWeight: 600 }}>En attente de validation</span>
                )}
                {spec.status === 'validated' && (
                    <span style={{ padding: '4px 10px', background: '#ecfdf5', color: '#047857', borderRadius: 99, fontSize: '0.75rem', fontWeight: 600 }}>Validé</span>
                )}
            </div>

            {spec.meeting_notes && (
                <div style={{ marginBottom: 24 }}>
                    <h4 style={{ fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--text-secondary, #64748b)', margin: '0 0 10px 0' }}>Synthèse des besoins</h4>
                    <div style={{
                        whiteSpace: 'pre-wrap',
                        background: 'var(--bg-secondary, #f8fafc)',
                        padding: 16,
                        borderRadius: 8,
                        fontSize: '0.95rem',
                        color: 'var(--text-primary, #334155)',
                        lineHeight: 1.6
                    }}>
                        {spec.meeting_notes}
                    </div>
                </div>
            )}

            {spec.roadmap && spec.roadmap.length > 0 && (
                <div>
                    <h4 style={{ fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--text-secondary, #64748b)', margin: '0 0 10px 0' }}>Roadmap & Tâches</h4>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 0, border: '1px solid var(--border-color, #e2e8f0)', borderRadius: 8, overflow: 'hidden' }}>
                        {spec.roadmap.map((task, idx) => (
                            <div key={task.id || idx} style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 16,
                                padding: '12px 16px',
                                background: task.done ? 'var(--bg-secondary, #f8fafc)' : 'white',
                                borderBottom: idx < spec.roadmap.length - 1 ? '1px solid var(--border-color, #f1f5f9)' : 'none'
                            }}>
                                <div style={{
                                    width: 24, height: 24, borderRadius: '50%',
                                    border: task.done ? 'none' : '2px solid #cbd5e1',
                                    background: task.done ? '#10b981' : 'transparent',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '0.9rem',
                                    flexShrink: 0
                                }}>
                                    {task.done && '✓'}
                                </div>
                                <div style={{ flex: 1 }}>
                                    {task.category && <span style={{ fontSize: '0.7rem', textTransform: 'uppercase', color: '#94a3b8', fontWeight: 700, display: 'block', marginBottom: 2 }}>{task.category}</span>}
                                    <span style={{
                                        fontSize: '0.95rem',
                                        textDecoration: task.done ? 'line-through' : 'none',
                                        color: task.done ? '#94a3b8' : '#334155'
                                    }}>
                                        {task.task}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ClientProjectSpecifications;
